import { EventDataContextProvider } from "@components/context/EventDataContext";
import { getEventData } from "@queries/events.queries";
import { setLanugage } from "@utils/api/axiosInstance";
import { appBaseUrl } from "@utils/BASE-URL";
import { LANGUAGE } from "@utils/constants";
import {
  generateSchemaForFAQ,
  generateSchemaForReviews,
} from "@utils/seo/generateScript";
import { Store } from "@utils/store/ContextStore";
import { getUserData } from "@utils/user";
import { isLoggedIn } from "@utils/user/userCheck";
import Head from "next/head";
import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import PujaDetailsAB from "src/pujaModule/views/singlePujaViewAB";

export default function EventsPage({ data, userData, lang }) {
  const { t } = useTranslation();
  const image = data?.images?.length > 0 ? data.images[0] : null;
  const { dispatch } = useContext(Store);
  const router = useRouter();
  const [cookies, setCookie] = useCookies([]);

  useEffect(() => {
    // const loadUserData = async () => {
    //   const userData = await getUserData(cookies);

    //   dispatch({
    //     type: "SET_DATA",
    //     payload: { userData, lang: userData.language || LANGUAGE.ENGLISH },
    //   });
    // };

    // loadUserData();

    // trackEvent(
    //   WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS +
    //     " " +
    //     WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED,
    //   {
    //     [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]:
    //       WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
    //     [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]:
    //       data?.name_WE || "Unknown Kriya",
    //     [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: data?.urlExtension,
    //   }
    // );
    // sessionStorage.setItem("locale", router.locale);
    // setLanugage(router.locale);
    dispatch({
      type: "SET_DATA",
      payload: { userData, lang },
    });
    // eslint-disable-next-line
  }, [userData, lang]);

  const temp = data?.description
    ? data?.description
    : `${t(
        "join-divine-communities-of-faith-and-spirituality-and-stay-updated-on-the-festivals-of-india"
      )}`;
  const description = temp.slice(0, 160);

  const constKeywords = `${t(
    "utsav-utsavapp-kriya-e-puja-prasad-home-delivery-online-puja-booking-online-puja-online-darshan-hindi-devotional-puja-app-darshan-app-online-puja-app-free-online-puja-hinduism-sanatan-dharma-lord-shiva-lord-krishna-indian-heritage-virtual-festivals-virtual-puja-locate-various-temple-connect-with-community-temples-of-india-festivals-community-platform-download-utsav-app-community-events-india-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief"
  )}`;

  const keywords = data?.CommunityEventAbouts
    ? data?.CommunityEventAbouts[0]
      ? data?.CommunityEventAbouts[0].keywords + constKeywords
      : constKeywords
    : constKeywords;

  return (
    <>
      <Head>
        <title>
          {data?.name ||
            `${t("puja-or-utsav-hindu-temple-online-puja-and-prasad")}`}
        </title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="keywords" content={keywords} />
        <meta name="description" content={description} />
        <meta
          property="title"
          content={
            keywords + " | " + data.name
              ? data.name + ` ${t("puja-on-utsav-app")}`
              : `${t("utsav-hindu-temple-online-puja-and-prasad")}`
          }
        />
        <meta
          property="og:title"
          content={
            keywords + " | " + data.name
              ? data.name + ` ${t("puja-on-utsav-app")}`
              : `${t("utsav-hindu-temple-online-puja-and-prasad")}`
          }
        />
        <meta property="og:type" content={t("article")} />
        <meta
          property="og:description"
          content={description + " | " + keywords}
        />

        <meta property="og:url" content="https://utsavapp.in" />
        <meta
          property="og:image"
          content={
            image ||
            "https://d3k1i85mml78tf.cloudfront.net/Feeds/1705393164851_post_image_2.jpg"
          }
          alt={
            data?.name
              ? data?.name + `${t("event-image")}`
              : `${t("utsav-puja-image")}`
          }
        />

        {data.EventDeityTypes[0]?.DeityType.name && (
            <link
              rel="canonical"
              href={`${appBaseUrl}/${router.locale}/puja/${
                data.EventDeityTypes[0]?.DeityType.name
              }/${data.urlExtension || data.eventID}`}
            />
          ) && (
            <link
              rel="alternate"
              href={`${appBaseUrl}/${router.locale}/puja/${
                data.EventDeityTypes[0]?.DeityType.name
              }/${data.urlExtension || data.eventID}`}
              hrefLang={router.locale}
            />
          ) && (
            <link
              rel="alternate"
              href={`${appBaseUrl}/puja/${
                data.EventDeityTypes[0]?.DeityType.name
              }/${data.urlExtension || data.eventID}`}
              hrefLang="x-default"
            />
          )}

        {data.Faqs?.length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(generateSchemaForFAQ(data.Faqs)),
            }}
          />
        )}

        {data.ReviewModels?.length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(generateSchemaForReviews(data)),
            }}
          />
        )}
      </Head>

      <EventDataContextProvider initialData={data}>
        <PujaDetailsAB />
      </EventDataContextProvider>
    </>
  );
}

export async function getServerSideProps(context) {
  try {
    const { req, res, locale, query, params } = context;
    let loggedIn = await isLoggedIn(req.headers.cookie, res);

    let userData = null;
    let lang = locale;

    if (loggedIn.value) {
      userData = loggedIn.data;
    }

    setLanugage(lang);

    let urlExtension;
    let deityTypeName;

    if (params.id && !params.eventid) {
      // urlExtension = params.eventid;
      urlExtension = params.id;
    }

    let emoji_regex = /\p{Extended_Pictographic}/gu;
    let special_character_regex = /[-|]/gi;
    let non_eng_regex = /[^\x00-\x7F]/g;

    if (
      special_character_regex.test(urlExtension) ||
      non_eng_regex.test(urlExtension)
    ) {
      urlExtension = urlExtension
        ? urlExtension
            .replace(special_character_regex, " ")
            .replace(non_eng_regex, "")
        : null;
      urlExtension = urlExtension.trim().replaceAll(" ", "-");
    }

    if (emoji_regex.test(urlExtension)) {
      urlExtension = urlExtension.replace(emoji_regex, "");
      urlExtension = urlExtension.slice(0, -1);
    }

    const { data: eventData, err } = await getEventData({
      eventID: urlExtension,
      language: locale,
      deityTypeName: deityTypeName,
    });

    // console.log("eventData => ", eventData, err);

    if (err || !eventData) {
      return {
        redirect: {
          destination: "/home",
          permanent: false,
        },
      };
    }

    return {
      props: {
        data: eventData,
        userData,
        lang,
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/home",
        permanent: false,
      },
    };
  }
}

// // This function gets called at build time on server-side.
// // It may be called again, on a serverless function, if
// // revalidation is enabled and a new request comes in
// export async function getStaticProps({ params, locale }) {
//   let urlExtension;
//   let deityTypeName;

//   if (params.id && params.eventid) {
//     urlExtension = params.eventid;
//     deityTypeName = params.id;
//   }

//   let emoji_regex = /\p{Extended_Pictographic}/gu;
//   let special_character_regex = /[-|]/gi;
//   let non_eng_regex = /[^\x00-\x7F]/g;

//   if (
//     special_character_regex.test(urlExtension) ||
//     non_eng_regex.test(urlExtension)
//   ) {
//     urlExtension = urlExtension
//       ? urlExtension
//           .replace(special_character_regex, " ")
//           .replace(non_eng_regex, "")
//       : null;
//     urlExtension = urlExtension.trim().replaceAll(" ", "-");
//   }

//   if (emoji_regex.test(urlExtension)) {
//     urlExtension = urlExtension.replace(emoji_regex, "");
//     urlExtension = urlExtension.slice(0, -1);
//   }

//   const { data: eventData, err } = await getEventData({
//     eventID: urlExtension,
//     language: locale,
//     deityTypeName: deityTypeName,
//   });

//   // console.log("eventData => ", eventData, err);

//   if (err || !eventData) {
//     // return {
//     //   redirect: {
//     //     destination: "/home",
//     //     permanent: false,
//     //   },
//     // };
//     return {
//       notFound: true,
//     };
//   }

//   // const { data: registrationsData } = await getEventAllRegistrations({
//   //   eventID: eventData.eventID,
//   // });

//   // const registrations = [];

//   // if (registrationsData) {
//   //   registrationsData?.forEach((e) => {
//   //     const tmp = {
//   //       User: e.User,
//   //       name: e.name,
//   //       city: e.CommunityEventParticipationAddress?.city ?? "",
//   //       state: e.CommunityEventParticipationAddress?.state ?? "",
//   //       ts: e.ts,
//   //     };

//   //     if (e.price) {
//   //       Object.assign(tmp, { price: e.price });
//   //     }

//   //     registrations.push(tmp);
//   //   });
//   // }

//   // const data = {
//   //   ...eventData,
//   //   registrations: registrations,
//   // };

//   return {
//     props: {
//       data: eventData,
//     },

//     // Next.js will attempt to re-generate the page:
//     // - When a request comes in
//     // - At most once every 10 seconds
//     // revalidate: 300, // In seconds (5-mins)
//   };
// }

// // This function gets called at build time on server-side.
// // It may be called again, on a serverless function, if
// // the path has not been generated.
// export async function getStaticPaths() {
//   const { data, err } = await getAllRevalidatedEvents();

//   const paths = [];
//   const languages = [LANGUAGE.ENGLISH, LANGUAGE.HINDI];

//   // Get the paths we want to pre-render based on posts
//   languages.forEach((lang) => {
//     data?.forEach((e) => {
//       if (e?.EventDeityTypes?.length === 0) {
//         paths.push({
//           params: { id: "other", eventid: e.eventID },
//           locale: lang,
//         });

//         if (e?.urlExtension) {
//           paths.push({
//             params: { id: "other", eventid: e.urlExtension },
//             locale: lang,
//           });
//         }
//       } else {
//         e.EventDeityTypes.forEach((deity) => {
//           paths.push({
//             params: {
//               id: deity?.DeityType.name,
//               eventid: e.eventID,
//             },
//             locale: lang,
//           });

//           if (e.urlExtension) {
//             paths.push({
//               params: {
//                 id: deity?.DeityType.name,
//                 eventid: e.urlExtension,
//               },
//               locale: lang,
//             });
//           }
//         });
//       }
//     });
//   });

//   // We'll pre-render only these paths at build time.
//   // { fallback: blocking } will server-render pages
//   // on-demand if the path doesn't exist.
//   return { paths, fallback: "blocking" };
// }
